import { useEffect, useState } from 'react';
import { orderBy } from 'lodash';
import { useDataService } from '../../../../../../services/ApiDataService';
import { CERTIFICATE_USAGES } from '../../../../certificates/CertificateConstants';

const CERTS_API = '/query/admin/nPointCertificate';

/**
 * Loads web-type certificates for the BTT certificate section.
 * Returns sorted certificate list and loading state.
 */
export function useBttCertificateData() {
    const [certificates, setCertificates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const dataService = useDataService();

    useEffect(() => {
        let cancelled = false;

        (async () => {
            setIsLoading(true);
            try {
                const result = await dataService.get(CERTS_API, {
                    certType: CERTIFICATE_USAGES.web,
                    limit: 9999,
                });
                if (cancelled) return;
                const certList = Array.isArray(result) ? result : result?.data || [];
                setCertificates(orderBy(certList, [(c) => (c.name || '').toLowerCase()]));
            } catch {
                if (!cancelled) setCertificates([]);
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [dataService]);

    return { certificates, isLoading };
}
